/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivityReportDetailsResource
 */
export interface ActivityReportDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof ActivityReportDetailsResource
     */
    lotIdToSubmit?: string;
}

/**
 * Check if a given object implements the ActivityReportDetailsResource interface.
 */
export function instanceOfActivityReportDetailsResource(value: object): value is ActivityReportDetailsResource {
    return true;
}

export function ActivityReportDetailsResourceFromJSON(json: any): ActivityReportDetailsResource {
    return ActivityReportDetailsResourceFromJSONTyped(json, false);
}

export function ActivityReportDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityReportDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'lotIdToSubmit': json['lotIdToSubmit'] == null ? undefined : json['lotIdToSubmit'],
    };
}

export function ActivityReportDetailsResourceToJSON(value?: ActivityReportDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lotIdToSubmit': value['lotIdToSubmit'],
    };
}

